module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f32a.065cf667.svg";